module.exports = "/images/OPO_portada.jpg?5949f335f1a50e06f3a394b19ccf2173";